import {
    Component,
    OnDestroy,
    HostListener,
    ElementRef,
    ChangeDetectorRef, OnInit, Output, EventEmitter
} from '@angular/core';
import {TreeNodeLMX} from "./tree-node-lmx";
import {TranslateService} from "../../../services/translate/translate.service";
import {GlobalModel} from "../../../services/state/global.model";
import {LumiSelectOption} from "../select/lumi-select/lumi-select.interface";
import {GlobalEvent} from "../../../interfaces/global-event";
import {StorageService} from "../../../services/storage/storage.service";
import {Subscription} from "rxjs";
import {AppSettings} from "../../../../app.settings";
import {ILabelConfig} from "./tree-filter.interface";

@Component ({
    selector: 'tree-filter-component',
    templateUrl: 'tree-filter.component.html',
    styleUrls: ['tree-filter.component.scss']
})

export class TreeFilterComponent implements OnInit, OnDestroy {
    @Output() onChange: EventEmitter<any> = new EventEmitter();
    public labelConfig: ILabelConfig = null;
    private subscriptions:Subscription[] = [];
    public objectTypeOptions:LumiSelectOption[] = [];
    public objectTypeOptionsSelected:LumiSelectOption[] =[];
    public isDropdownOpen:boolean = false;

    constructor(public ts:TranslateService, private model:GlobalModel, private eRef: ElementRef) {
        this.subscriptions.push(this.model.availableOptionTypes.subscribe((value) => {
            this.objectTypeOptions = this.convertToLumiSelect(value);
        }));
        this.subscriptions.push(this.model.selectedOptionTypes.subscribe((value) => {
            this.objectTypeOptionsSelected = this.convertToLumiSelect(value);
        }));
    }

    ngOnInit() {
        this.labelConfig = {
            label: this.ts.translate('tree-filter.select-objecttypes'),
            required: false,
            disabled: false,
            attr: {
                "batch-update": false,
                infoText: this.ts.translate('tree-filter.select-objecttypes-info'),
            }
        }
    }

    @HostListener('document:click', ['$event'])
    clickout(event) {
        if(this.isDropdownOpen && !this.eRef.nativeElement.contains(event.target)) {
            this.toggleDropdown();
        }
    }

    public hasChangedObjectTypes():boolean{
        return this.model.selectedOptionTypes.value.length != this.model.availableOptionTypes.value.length;
    }

    public clearSelection():void{
        this.model.selectedOptionTypes.next(this.model.availableOptionTypes.value);
    }

    public onOptionsSelect(selectedOption: LumiSelectOption[]):void {
        let newSelectedOptions:string[] = [];
        selectedOption.map(_x => {
            newSelectedOptions.push(String(_x.id))
        })
        this.model.selectedOptionTypes.next(newSelectedOptions);
        this.onChange.emit();
    }

    private convertToLumiSelect(stringValue:string[]):LumiSelectOption[]{
        let lumiSelectVariable:LumiSelectOption[] = [];
        stringValue.map(_x => {
            lumiSelectVariable.push({
                id:_x,
                name:this.translateObjectType(_x)
            })
        })
        return lumiSelectVariable;
    }

    private translateObjectType(objectType:string):string{
        switch(objectType){
            case 'schakelkast':
                return this.ts.translate('objecttype.schakelkast');
            case 'mast':
                return this.ts.translate('objecttype.mast');
            case 'lamp':
                return this.ts.translate('objecttype.lamp');
            case 'armatuur':
                return this.ts.translate('objecttype.armatuur');
            case 'olc':
                return this.ts.translate('objecttype.olc');
            case 'vsa':
                return this.ts.translate('objecttype.vsa');
            case 'cable':
                return this.ts.translate('objecttype.kabel');
            case 'wire':
                return this.ts.translate('objecttype.draad');
            case 'conduit':
                return this.ts.translate('objecttype.leiding');
            case 'joint':
                return this.ts.translate('objecttype.joint');
            case 'annotation':
                return this.ts.translate('objecttype.annotation');
            case 'genericasset':
                return this.ts.translate('objecttype.genericasset');
            default:
                return objectType.charAt(0).toUpperCase() + objectType.slice(1);
        }
    }

    public toggleDropdown():void{
        this.isDropdownOpen = !this.isDropdownOpen;
    }

    ngOnDestroy() {
        this.subscriptions.forEach((_x)=>{_x.unsubscribe()})
    }
}
